export default __webpack_public_path__ + "static/pragicts-digital-outreach-verticals-agriculture-drones-7a39242d481b9c0381d11454bf643ba0.jpg";